/**
 * 將數量收斂到 [minQty, availableQty]（可用量至少為 minQty）。
 * 空白／非數字／低於下限 → minQty；超過可用量 → availableQty。
 *
 * @param {unknown} rawValue
 * @param {unknown} availableQty
 * @param {number} [minQty=1]
 * @returns {number}
 */
export function clampQtyToAvailable(rawValue, availableQty, minQty = 1) {
  const availableNum = Math.max(minQty, Number(availableQty) || minQty);
  if (rawValue === '' || rawValue == null) {
    return minQty;
  }
  const parsed = Number(rawValue);
  if (!Number.isFinite(parsed)) {
    return minQty;
  }
  return Math.min(availableNum, Math.max(minQty, parsed));
}
